<template>
    <div>
        <a-table size="small" :pagination="false" :locale="{ emptyText:'还没有存档' }"
            :columns="columns" :data-source="data" rowKey="name"
        >
            <a class="tower-title" slot="name" slot-scope="title, record" :href="`/games/${ record.name }`" target="_blank">{{ title }}</a>
            <span slot="size" slot-scope="size">{{ formatSize(size) }}</span>
            <template slot="action" slot-scope="name">
                <a-button icon="export" type="link" size="small" @click="download(name)">导出</a-button>
                <a-button icon="delete" type="link" size="small" @click="clear(name)">清除</a-button>
            </template>
            <a-space slot="footer" size="middle" v-if="data.length">
                总个数: {{ data.length }} 总大小: {{ totalSize }}
                <a-button icon="export" type="primary" @click="download()">全部导出</a-button>
                <a-button icon="delete" type="danger" @click="clear()">全部清除</a-button>
            </a-space>
        </a-table>
    </div>
</template>

<script>
import { formatSize } from '../../../utils/utils'

export default {
    props: [ 'data' ],
    computed: {
        totalSize() {
            return formatSize(this.data.reduce((s, e) => s + e.size, 0));
        },
    },
    data: () => ({
        columns: [
            { title: '塔名', dataIndex: 'title', slot: 'name' },
            { title: '存档数', dataIndex: 'num' },
            { title: '占用空间', dataIndex: 'size', slot: 'size' },
            { title: '操作', dataIndex: 'name', slot: 'action' },
        ].map(e => e.slot ? { ...e, scopedSlots: { customRender: e.slot } } : e )
    }),
    methods: {
        formatSize,
        download(name) {
            this.$emit("download", name);
        },
        clear(name) {
            this.$emit("clear", name);
        },
    }
}
</script>

<style lang="less" scoped>
.ant-space {
    width: 100%;
    div:first-child {
        margin-left: auto;
    }
    padding-right: 5%;
}
</style>